export const tableData = [
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3K",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
  {
    promotion: "Nike",
    posts: "786.3k",
    emv: "$431.1k",
    "share of value": "7.5%",
  },
];

export const tableColumns = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Mentions",
    accessor: "mentions",
  },
  {
    Header: "AVE",
    accessor: "AVE",
  },
  {
    Header: "Share",
    accessor: "Share",
  },
];

export const tableColumns1 = [
  {
    Header: "Language",
    accessor: "language",
  },
  {
    Header: "Articles",
    accessor: "articles",
  },
  {
    Header: "AVE",
    accessor: "AVE",
  },
  {
    Header: "Share",
    accessor: "Share",
  },
];
